(() => {
  if (window.munchkinPilotMounted) return;
  window.munchkinPilotMounted = true;
  function apply(id) {
    const root = document.querySelector('.munchkin-pilot');
    const source = document.getElementById('MunchkinPilotData');
    if (!root || !source) return;
    const data = JSON.parse(source.textContent);
    const variant = data.variants[String(id || data.initial)];
    if (!variant) return;
    root.dataset.pilotColor = variant.color;
    const lifestyle = root.querySelector('.munchkin-guide__lifestyle img');
    if (lifestyle && variant.lifestyle) {
      lifestyle.removeAttribute('srcset');
      lifestyle.src = variant.lifestyle + '&width=1000';

    }
    const packshot = root.querySelector('.munchkin-guide__image img');
    if (packshot && data.images[String(id || data.initial)]) {
      packshot.removeAttribute('srcset');
      packshot.src = data.images[String(id || data.initial)];
    }
  }
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-picker[data-template-product-match="true"]');
    const source = document.getElementById('MunchkinPilotData');
    if (!picker || !source || picker.dataset.productId !== String(JSON.parse(source.textContent).productId)) return;
    const option = event.target instanceof HTMLSelectElement ? event.target.selectedOptions[0] : event.target;
    if (option?.dataset.variantId) apply(option.dataset.variantId);
  });
  document.addEventListener('shopify:section:load', () => apply());
  apply();
})();
